export default __webpack_public_path__ + "static/traefik-enterprise-logo-e2d90755fc35037bdc006a3c12849cdf.svg";